import { render, staticRenderFns } from "./addCommissionDialog.vue?vue&type=template&id=978f6d30"
import script from "./addCommissionDialog.vue?vue&type=script&lang=js"
export * from "./addCommissionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports